/**
 * Cart drawer — Alpine store + per-line-item component.
 * Extracted from snippets/cart-drawer.liquid.
 *
 * No Liquid lives in this file. Dynamic data is read from the DOM at runtime:
 *   - Initial cart state from the #cart-data JSON island.
 *   - The cart URL from the #cart-drawer element's data-cart-url attribute.
 */
document.addEventListener('alpine:init', () => {
  const readInitialCart = () => {
    const el = document.getElementById('cart-data');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch {
      return {};
    }
  };

  const getCartUrl = () => document.getElementById('cart-drawer')?.dataset.cartUrl || '/cart';

  Alpine.store('cartDrawerStore', {
    cartDrawOpen: false,
    loading: false,
    cart: readInitialCart(),

    open() {
      this.cartDrawOpen = true;
      Alpine.store('bodyOverflowHidden').lock('cart-drawer');
    },
    close() {
      this.cartDrawOpen = false;
      Alpine.store('bodyOverflowHidden').unlock('cart-drawer');
      this.reloadCartDrawer();
    },
    reloadCartDrawer() {
      this.loading = true;
      const wasOpen = this.cartDrawOpen;

      fetch(`${getCartUrl()}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const cartData = html.getElementById('cart-data')
            ? JSON.parse(html.getElementById('cart-data').innerText)
            : '';
          setTimeout(() => {
            this.loading = false;
          }, 150);
          document.getElementById('cart-drawer').innerHTML = html.getElementById('cart-drawer').innerHTML;
          if (cartData) this.cart = cartData;

          /* SDICSP-73: Safety check to ensure overflow is unlocked if drawer was closed during reload */
          if (wasOpen && !this.cartDrawOpen) {
            Alpine.store('bodyOverflowHidden').unlock('cart-drawer');
          }

          window.dispatchEvent(new CustomEvent('cart-drawer:updated'));
        })
        // eslint-disable-next-line no-console
        .catch((error) => console.error(error));
    },
    removeItem(key) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.cart = data;
          this.reloadCartDrawer();
        })
        // eslint-disable-next-line no-console
        .catch((error) => console.error(error));
    },
    updateQuantity(key, newQuantity) {
      if (newQuantity < 1) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQuantity }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.cart = data;
          this.reloadCartDrawer();
        })
        // eslint-disable-next-line no-console
        .catch((error) => console.error(error));
    },
  });

  Alpine.data('cartDrawerItem', (initialQty, _variantId, itemKey, maxLimit, physicalStock, absoluteLimit) => {
    return {
      qty: initialQty,
      rawInput: initialQty,
      maxQty: maxLimit ? Number(maxLimit) : null,
      stockQty: physicalStock ? Number(physicalStock) : null,
      metaLimit: absoluteLimit ? Number(absoluteLimit) : null,
      showLimitMsg: false,
      msgType: '',

      init() {
        this.checkLimits(false);
      },

      checkLimits(isInteraction = false) {
        const ceiling = this.maxQty ?? Infinity;

        if (this.rawInput >= ceiling) {
          if (this.rawInput > ceiling) {
            this.rawInput = ceiling;
          }

          const isStockBottleneck = this.stockQty <= this.metaLimit;

          if (isStockBottleneck) {
            this.msgType = 'stock';
            this.showLimitMsg = isInteraction;
          } else {
            this.msgType = 'limit';
            this.showLimitMsg = true;
          }
        } else {
          this.showLimitMsg = false;
          this.msgType = '';
        }
        this.qty = this.rawInput;
      },

      handleInput() {
        this.checkLimits(true);
      },

      validateAndUpdate() {
        if (this.rawInput < 1) {
          this.rawInput = 1;
          this.qty = 1;
        }
        this.checkLimits(true);
        Alpine.store('cartDrawerStore').updateQuantity(itemKey, this.qty);
      },
    };
  });
});
